import { MapTo } from '@adobe/aem-react-editable-components';
import SchumerTable, { SchumerTableEditConfig } from './SchumerTable';

export default MapTo('cob-corp-acquisition/components/creditonebank/schumer-table')(SchumerTable, SchumerTableEditConfig);